"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Style = _interopRequireWildcard(require("./Badge.styles"));
var _Badge2 = require("./Badge.types");
var _excluded = ["className", "size", "count", "variant", "kind"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var MAX_COUNT = 99;
var Badge = function Badge(_ref) {
  var className = _ref.className,
    size = _ref.size,
    count = _ref.count,
    variant = _ref.variant,
    kind = _ref.kind,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Style.Badge, _extends({
    className: (0, _clsx["default"])('Cozy__Badge', className),
    $content: count > MAX_COUNT ? "".concat(MAX_COUNT, "+") : "".concat(count),
    $size: size === 'default' ? _Badge2.Size.MEDIUM : size // TODO: Remove 'default' in the future, leaving for now just to keep compatibility
    ,

    $variant: variant,
    $kind: kind
  }, props));
};
Badge.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string,
  count: _propTypes["default"].number,
  size: _propTypes["default"].oneOf(Object.values(_Badge2.Size)),
  variant: _propTypes["default"].oneOf(Object.values(_Badge2.Variant)),
  kind: _propTypes["default"].oneOf(Object.values(_Badge2.Kind))
} : {};
Badge.defaultProps = {
  size: _Badge2.Size.MEDIUM,
  variant: _Badge2.Variant.DEFAULT,
  kind: _Badge2.Kind.DEFAULT
};
var _default = exports["default"] = Badge;